<template>
  <div class="bullet-graph">
    <b-progress
      :value="progress"
      :max="100"
      :variant="variantValue"
    ></b-progress>
    <span
      v-if="comparativeProgress !== null"
      class="incremental"
      :style="`left:${Math.max(0, Math.min(comparativeProgress, 100))}%;`"
    >
      <span
        ref="comparative_line"
        class="line"
      ></span>
      <span
        :class="[
          'label',
          {
            'label-left': comparativeProgress > 75,
            'label-right': comparativeProgress < 25,
            'label-center': comparativeProgress >= 25 && comparativeProgress <= 75
          }
        ]"
      >
        <span
          ref="comparative"
          class="tooltip-wrapper"
        >
          {{ comparativeProgressLabel }}
        </span>
      </span>
    </span>
    <b-tooltip
      v-if="comparativeProgress !== null"
      :target="() => $refs['comparative']"
      placement="top"
      variant="flat-peter-river"
    >
      <slot name="tooltip">
        Previous period
      </slot>
    </b-tooltip>
    <b-tooltip
      v-if="comparativeProgress !== null"
      :target="() => $refs['comparative_line']"
      placement="top"
      variant="flat-peter-river"
    >
      <slot name="tooltip">
        Previous period
      </slot>
    </b-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.bullet-graph {
  position: relative;

  .progress {
    border-radius: 0;
  }

  .incremental {
    top: -17px;
    position: absolute;
    display: block;

    .label {
      display: block;
      position: absolute;
      font-size: 0.7rem;
      width: 100px;

      &.label-center {
        margin-left: -50px;
        left: 50%;
        text-align: center;
      }

      &.label-left {
        margin-left: -90px;
        text-align: right;
      }

      &.label-right {
        margin-left: -10px;
        text-align: left;
      }
    }

    .line {
      position: absolute;
      display: block;
      top: 20px;
      left: 0;
      border-right: 3px solid #333;
      height: 26px;
    }
  }
}
</style>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true
    },
    comparativeProgress: {
      type: Number,
      default: null
    },
    comparativeProgressTarget: {
      type: Number,
      default: null
    },
    comparativeProgressLabel: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: null
    }
  },
  computed: {
    variantValue () {
      if (this.variant) {
        return this.variant
      }

      let variant = 'progress'
      let good = 'success'
      let bad = 'danger'
      let warning = 'warning'

      if (this.comparativeProgress !== null) {
        if (this.inverse) {
          if (this.comparativeProgressTarget !== null) {
            if (this.progress <= this.comparativeProgressTarget) {
              variant = good
            } else if (this.progress < this.comparativeProgress) {
              variant = warning
            } else {
              variant = bad
            }
          } else {
            if (this.progress <= this.comparativeProgress) {
              variant = good
            } else {
              variant = bad
            }
          }
        } else {
          if (this.comparativeProgress - this.progress > 0) {
            variant = bad
          } else if (this.comparativeProgressTarget !== null && this.progress < this.comparativeProgressTarget) {
            variant = warning
          } else {
            variant = good
          }
        }
      } else {
        if (this.inverse) {
          if (this.progress <= 5) {
            variant = good
          } else if (this.progress <= 50) {
            variant = warning
          } else {
            variant = good
          }
        } else {
          if (this.progress >= 95) {
            variant = good
          } else if (this.progress > 50) {
            variant = warning
          } else {
            variant = bad
          }
        }
      }
      return variant
    }
  }
}
</script>